import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';

@Component({
  selector: 'app-analysis1',
  templateUrl: './analysis1.component.html',
  styleUrls: ['./analysis1.component.scss']
})
export class Analysis1Component implements OnInit {

  constructor(public appservice: AppService) { }

  ngOnInit(): void {
  }

}
